"use client";

import { useContext } from "react";
import {
  AppControllerContext,
  type AppControllerContextState,
} from "../contexts";

/**
 * Provides the app controller context.
 * @returns The app controller context.
 */
export const useAppController = (): AppControllerContextState => {
  const context = useContext(AppControllerContext);
  if (!context) {
    throw new Error(
      "useAppController must be used within a AppControllerProvider",
    );
  }
  return context;
};

/**
 * Provides the app controller context.
 * @returns The app controller context.
 */
export const useMaybeAppController = ():
  | AppControllerContextState
  | undefined => {
  return useContext(AppControllerContext);
};
